import { PhotoType } from "../../utils/types"

// eslint-disable-next-line no-restricted-syntax
export enum ExtraIcons {
  PhotoAndUnderwriting = "PhotoAndUnderwriting",
  WatchOutOfCars = "WatchOutOfCars",
  MakeRoom = "MakeRoom",
  PermissionsLocation = "PermissionsLocation",
  PermissionsGps = "PermissionsGps",
  Sent = "Sent",
  Expired = "Expired",
  Wait = "Wait",
  DocumentsIntro = "DocumentsIntro",
  IncompatiblePhone = "IncompatiblePhone",
  Vehicle = "Vehicle",
  DamageDetail = "DamageDetail",
  DamageAddMore = "DamageAddMore",
}

// TODO podivat se na tu variant
export type InstructionImageProps = {
  iconName: PhotoType | ExtraIcons
  variant?: "primary" | "secondary"
  animated?: boolean
  className?: string
}
